/* ============================================================
   TECH BUZZ � Custom JavaScript
   Scroll animations + Header scroll opacity
   ============================================================ */

(function () {
  'use strict';

  /* -- 1. Scroll Animation Observer ---------------------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tb-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    function initObserver() {
      document.querySelectorAll('.tb-fade-up, .tb-stagger').forEach(function (el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initObserver);
    } else {
      initObserver();
    }
  } else {
    /* Reduced motion � show all immediately */
    document.querySelectorAll('.tb-fade-up, .tb-stagger').forEach(function (el) {
      el.classList.add('tb-visible');
    });
  }

  /* -- 2. Header Scroll Opacity --------------------------- */
  function initHeaderScroll() {
    var header = document.querySelector('#header-component');
    if (!header) return;

    var ticking = false;
    var scrollContainer = document.querySelector('.page-wrapper') || window;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var scrollY = scrollContainer === window
            ? window.scrollY
            : scrollContainer.scrollTop;

          if (scrollY > 60) {
            header.classList.add('header--scrolled');
          } else {
            header.classList.remove('header--scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    scrollContainer.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -- 3. Cart Drawer Animation --------------------------- */
  function initCartAnimations() {
    document.addEventListener('cart:open', function () {
      var cartDrawer = document.querySelector('.cart-drawer');
      if (cartDrawer) cartDrawer.classList.add('tb-cart-open');
    });
    document.addEventListener('cart:close', function () {
      var cartDrawer = document.querySelector('.cart-drawer');
      if (cartDrawer) cartDrawer.classList.remove('tb-cart-open');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHeaderScroll();
      initCartAnimations();
    });
  } else {
    initHeaderScroll();
    initCartAnimations();
  }

})();
